import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <CommentsSection />
        <ContactSection />
        <MediaSection />
        <CardsSection />
        <IndexSection />
        <FaqSection />
        <UpdatesSection />
        <FeaturesSection />
        <AppSection />
        <TopicsSection />
        <AboutSection />
        <CarouselSection />
      </main>
      <FooterSection />
    </>
  );
}